// This deployment's client identity — never hardcode the company in frontend code.
// The repo-wide source of truth is the committed root client.json (companyCode);
// the value is baked here because the bundle doesn't ship the repo root.
// scripts/check_client_identity.py verifies the two stay in sync — after changing
// client.json (e.g. in a repo copied for a new client), run it to find every baked copy.
export const COMPANY_CODE = "lmnt";
